import { useState, useEffect } from 'react';

/**
 * Hook to detect if the current device is a mobile/touch device
 * Uses both screen width and touch capability detection
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;

    // Check for touch capability
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Check screen width
    const isNarrow = window.innerWidth < breakpoint;

    // Consider mobile if narrow screen OR touch-only device
    return isNarrow || (hasTouch && !window.matchMedia('(pointer: fine)').matches);
  });

  useEffect(() => {
    const checkMobile = () => {
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isNarrow = window.innerWidth < breakpoint;
      // pointer: fine means precise pointer (mouse), coarse means touch
      const isTouchOnly = hasTouch && !window.matchMedia('(pointer: fine)').matches;

      setIsMobile(isNarrow || isTouchOnly);
    };

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}
